var $ = require('../internals/export');
var $parseInt = require('../internals/number-parse-int');

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != $parseInt }, {
  parseInt: $parseInt
});



//////////////////
// WEBPACK FOOTER
// /var/www/html/wp-content/themes/sage/node_modules/simplebar/node_modules/core-js/modules/es.parse-int.js
// module id = 186
// module chunks = 0